import { render } from "./InventorySearch.vue?vue&type=template&id=5a560ffe"
import script from "./InventorySearch.vue?vue&type=script&lang=js"
export * from "./InventorySearch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/inv/inertia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__